import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

function UnauthenticatedOutlet() {
  const { isAuthenticated } = useAppContext();
  const [searchParams] = useSearchParams();

  return isAuthenticated ? <Navigate to={searchParams.get('redirect') || '/'} /> : <Outlet />;
}

export default UnauthenticatedOutlet;
